import React, { MutableRefObject } from "react";

import { TabItem, TabControl } from "../tabControl/TabControl";

import "./TabList.scss";

interface TabListProps {
  items: TabItem[];
  selected?: string;
  onClick?: (id: string) => void;
  tabsRef?: MutableRefObject<HTMLUListElement>;
  ariaLabel?: string;
}

export const TabList = ({
  items = [],
  tabsRef,
  selected,
  onClick,
  ariaLabel,
}: TabListProps) => {
  return (
    <ul className="tab-list" aria-label={ariaLabel} ref={tabsRef}>
      {items.map((item) => (
        <li className="tab-item" key={item.id}>
          <TabControl
            item={item}
            selected={selected === item.id}
            onClick={onClick}
          />
        </li>
      ))}
    </ul>
  );
};
